module.exports = __webpack_public_path__ + "static/media/circle-declined.68989da2.svg";